import { Component,OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationError , NavigationCancel, NavigationStart } from '@angular/router';

import {CommonService} from "./common.service"
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent  implements OnInit  {
  title = 'BOCW';

  //isBusy=this.CSF.isLoading();
  constructor(public CSF:CommonService,private router: Router){

  }
  ngOnInit() {
        this.router.events.subscribe((evt) => {
            // if (!(evt instanceof NavigationEnd)) {
            //     return;
            // }
            if (evt instanceof NavigationStart) {
              // show spinner
               let urlToRedirect=evt.url;
                if(sessionStorage.NUTR){
                  let p=  sessionStorage.getItem('NUTR')
                  sessionStorage.setItem('PUTR',p);
                  sessionStorage.removeItem('isFirst');
                }else{
                    sessionStorage.setItem('PUTR',urlToRedirect);
                    sessionStorage.setItem('isFirst','true');
                }
                sessionStorage.setItem('NUTR',urlToRedirect)



              this.CSF.setBusyStatus(true);
          } else if ( evt instanceof NavigationError  || evt instanceof NavigationCancel || evt instanceof NavigationEnd) {
              this.CSF.setBusyStatus(false);
          }
            window.scrollTo(0, 0);
        });
    }

    
    
}


